export default __webpack_public_path__ + "static/foto3-f50a331bbc24f8e8b4259b3307a24efe.jpg";